import React, { useEffect, useState } from "react";
import {apiRequest, API_CONSTANTS} from "../libs/apiRequest";
import {
    actionUpdateKeyValueSubscription
} from "../store/subscription";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import planFeatures from "../libs/planFeatures";
import GTCReminder from "../components/GTCReminder";
import { FaCheck, FaRocket } from 'react-icons/fa';
import '../css/gtc-subscription-plans.css';

let features = planFeatures.default;

function GTCSubscriptionPlans() {
    const [subscriptions, setSubscriptions] = useState<any[]>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { service } = useParams();

    const numberFormat = (limit: number) => {
        if (limit < 1000000) {
            return `${Number((limit / 1000).toFixed(1))}K`
        }
        else {
            return `${Number((limit / 1000000).toFixed(1))}M`
        }
    }

    features = service == "geo" ? planFeatures.default : planFeatures.rplansFeatures;

    const getSubscriptions = async () => {
        try {
            const data = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "subscriptions",
                data: {
                    service: service
                }
            });
            // console.log("getSubscriptions", data)
            if (data && data.status == 200) {
                setSubscriptions(data.data.plans);
                dispatch(actionUpdateKeyValueSubscription({ clientId: data.data.clientId}));
            }
        } catch (error) {
            console.log("getSubscriptions", error);
        }
    }

    const selectPlan = async (plan: any) => {
        // console.log(location.pathname)
        navigate(`${location.pathname}/${plan.key}`)
        dispatch(actionUpdateKeyValueSubscription({ plan: plan }))
    }

    useEffect(() => {
        getSubscriptions();
    }, []);

    return (
        <div className="subscription-page">
            <div className="plans-header">
                <div className="container">
                    <h1 className="plans-title">Choose Your Plan</h1>
                    <p className="plans-description">
                        Select the perfect plan for your needs
                    </p>
                </div>
            </div>

            <div className="container">
                <GTCReminder 
                        reminder={"If you are subscribed to one of the plans, it will automatically be downgraded or upgraded if you choose any of these plans now."}
                    />

                <div className="plan-grid">
                    {subscriptions.filter((plan) => plan.key != "free").sort((a, b) => {
                        if(a.key < b.key) { return -1; }
                        if(a.key > b.key) { return 1; }
                        return 0;
                    }).map((plan, i) => {
                        console.log(plan)
                        return (
                            <div key={i} className="plan-card">
                                <div className="plan-header">
                                    <h2 className="plan-title">{plan.title}</h2>
                                    <div className="plan-price">
                                        <span className="price-currency">$</span>
                                        {plan.price}
                                    </div>
                                    <p className="plan-description">{plan.desc}</p>
                                    <div className="request-limit">
                                        {numberFormat(plan.limit)} API Requests
                                    </div>
                                </div>
    
                                <button 
                                    className="subscribe-button"
                                    onClick={() => selectPlan(plan)}
                                >
                                    Subscribe Now
                                </button>
                            </div>
                        )
                    })}
                </div>

                <div className="features-container">
                    <div className="features-header">
                        <FaRocket className="features-icon" />
                        <h2>All Plans Include</h2>
                        <p>Every subscription plan comes with these powerful features</p>
                    </div>
                    <div className="features-grid">
                        {features.map((feature, i) => (
                            <div key={i} className="feature-item">
                                <FaCheck className="feature-icon" />
                                <div className="feature-content">
                                    <span>{feature.replace(/{{limit}}/g, 'allocated')}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GTCSubscriptionPlans;